import _styled8 from "styled-components";
import _styled7 from "styled-components";
import _styled6 from "styled-components";
import _styled5 from "styled-components";
import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
import SelectBox from '../SelectBox';
export var CREATE_TYPE = '__selectbox_create_option__';
export function defaultMenuRenderer(_ref) {
  var items = _ref.items,
      renderItem = _ref.renderItem;
  return items.map(function (item, index) {
    return renderItem({
      item: item,
      index: index
    });
  });
}
export function defaultValueRenderer(value, _ref2) {
  var disabled = _ref2.disabled,
      stateAndHelpers = _ref2.stateAndHelpers;
  var itemToString = stateAndHelpers.itemToString;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: [theme.typography.labelMedium, {
      color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal900,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }]
  }, itemToString(value));
}
export function defaultValueTagRenderer(item, selectProps) {
  var disabled = selectProps.disabled,
      valueKey = selectProps.valueKey,
      labelKey = selectProps.labelKey,
      subtextKey = selectProps.subtextKey,
      container = selectProps.container,
      stateAndHelpers = selectProps.stateAndHelpers;
  var isOpen = stateAndHelpers.isOpen,
      closeMenu = stateAndHelpers.closeMenu,
      getItemProps = stateAndHelpers.getItemProps,
      getValueTagProps = stateAndHelpers.getValueTagProps;
  var content = item[labelKey] || item[subtextKey];
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    key: item[valueKey],
    "data-testid": "SelectBox__tag"
  }, getValueTagProps, {
    $_css2: [theme.typography.bodyMedium, {
      display: 'flex',
      flexDirection: 'row',
      maxWidth: 200,
      height: 27,
      padding: '0 6px',
      margin: '3px 6px 3px 0',
      color: theme.colors.charcoal900,
      backgroundColor: theme.colors.charcoal100,
      borderRadius: 4,
      border: 'none',
      alignItems: 'center',
      cursor: 'default'
    }]
  }), /*#__PURE__*/React.createElement(OverflowTooltip, {
    singleLine: true,
    autoTipOnEllipsis: true,
    container: container,
    getTargetProps: function getTargetProps() {
      return {
        style: {
          maxWidth: 172
        }
      };
    }
  }, content), !disabled && /*#__PURE__*/React.createElement(Icon, {
    size: 12,
    type: Icon.TYPES.X,
    style: {
      marginLeft: 4
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      getItemProps({
        item: item
      }).onClick(e);
      if (!isOpen) closeMenu();
    }
  }));
}
export function defaultLabelRenderer(label, subtext, disabled) {
  return /*#__PURE__*/React.createElement(_StyledDiv2, {
    title: typeof label === 'string' ? label : undefined,
    $_css3: [theme.typography.ellipsis, {
      color: disabled ? theme.colors.charcoal500 : theme.colors.charcoal900
    }]
  }, label, !!subtext && /*#__PURE__*/React.createElement(_StyledDiv3, {
    title: typeof subtext === 'string' ? subtext : undefined,
    $_css4: [theme.typography.ellipsis, theme.typography.bodyMedium, _objectSpread({}, !disabled && {
      color: theme.colors.charcoal700
    })]
  }, subtext));
}
export function defaultOptionRenderer(option, selected, selectProps, disabled) {
  var labelKey = selectProps.labelKey,
      labelGetter = selectProps.labelGetter,
      subtextKey = selectProps.subtextKey,
      subtextGetter = selectProps.subtextGetter;
  var label = labelGetter ? labelGetter(option) : option[labelKey];
  var subtext = subtextGetter ? subtextGetter(option) : option[subtextKey];
  return defaultLabelRenderer(label, subtext, disabled);
}
export function defaultCreateOptionRenderer(option, selected, selectProps, disabled) {
  var labelKey = selectProps.labelKey,
      labelGetter = selectProps.labelGetter,
      subtextKey = selectProps.subtextKey,
      subtextGetter = selectProps.subtextGetter;
  var label = labelGetter ? labelGetter(option) : option[labelKey];
  if (!selected) label = selectProps['T'].translate('CREATE_OPTION', {
    label: label
  });
  var subtext = subtextGetter ? subtextGetter(option) : option[subtextKey];
  return defaultLabelRenderer(label, subtext, disabled);
}
export function defaultItemRenderer(_ref3) {
  var item = _ref3.item,
      index = _ref3.index,
      selected = _ref3.selected,
      disabled = _ref3.disabled,
      itemProps = _ref3.itemProps,
      selectProps = _ref3.selectProps;
  var multiple = selectProps.multiple,
      _selectProps$optionRe = selectProps.optionRenderer,
      optionRenderer = _selectProps$optionRe === void 0 ? defaultOptionRenderer : _selectProps$optionRe,
      _selectProps$createOp = selectProps.createOptionRenderer,
      createOptionRenderer = _selectProps$createOp === void 0 ? defaultCreateOptionRenderer : _selectProps$createOp,
      groupLabelKey = selectProps.groupLabelKey;
  var highlighted = itemProps.highlighted;
  var isGroupedSelectBox = !!groupLabelKey;

  if (item[CREATE_TYPE] && !selected) {
    return /*#__PURE__*/React.createElement("li", itemProps, createOptionRenderer(item, selected, selectProps, disabled));
  }

  return /*#__PURE__*/React.createElement(_StyledLi, _extends({
    "data-testid": "SelectBox__option--".concat(index)
  }, itemProps, {
    $_css5: [_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      cursor: 'pointer',
      display: 'flex',
      padding: "".concat(index === 0 && !isGroupedSelectBox ? 16 : 8, "px 16px 8px"),
      backgroundColor: theme.colors.white
    }, !disabled && (!selected || multiple) && {
      '&:hover': {
        backgroundColor: theme.colors.charcoal050
      },
      '&:active': {
        backgroundColor: theme.colors.charcoal100
      }
    }), disabled && {
      cursor: 'default'
    }), !disabled && highlighted && {
      backgroundColor: theme.colors.charcoal050
    }), selected && !multiple && _objectSpread({
      backgroundColor: theme.colors._adskBlue100Alpha
    }, theme.typography.bodyMediumBold))]
  }), multiple && /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css6: [_objectSpread(_objectSpread({
      alignItems: 'center',
      borderRadius: 2,
      display: 'flex',
      flexShrink: 0,
      height: 16,
      marginRight: 8,
      marginTop: 2,
      width: 16
    }, !selected && {
      border: "1px solid ".concat(theme.colors.charcoal400)
    }), selected && {
      backgroundColor: theme.colors.adskBlue500,
      color: theme.colors.white,
      fontSize: 10
    })]
  }, selected && /*#__PURE__*/React.createElement(Icon, {
    type: Icon.TYPES.CHECKMARK,
    size: 16
  })), optionRenderer(item, selected, selectProps, disabled), !multiple && /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css7: [{
      flex: 1
    }]
  }), !multiple && selected && /*#__PURE__*/React.createElement(Icon, {
    style: {
      color: theme.colors.adskBlue500,
      flexShrink: 0,
      marginLeft: 8
    },
    size: 24,
    type: Icon.TYPES.CHECKMARK
  }));
}
export function defaultFilterOptions(options, inputValue, selectProps) {
  var search = inputValue.trim().toLowerCase();
  if (!search) return options;
  var labelKey = selectProps.labelKey,
      labelGetter = selectProps.labelGetter,
      subtextKey = selectProps.subtextKey,
      subtextGetter = selectProps.subtextGetter;
  return options.filter(function (option) {
    var label = labelGetter ? labelGetter(option) : option[labelKey];
    var subtext = subtextGetter ? subtextGetter(option) : option[subtextKey];
    return label && label.toLowerCase().indexOf(search) >= 0 || subtext && subtext.toLowerCase().indexOf(search) >= 0;
  });
}
export function defaultSelectBoxRenderer(props) {
  return /*#__PURE__*/React.createElement(SelectBox, props);
}
export function defaultGroupHeaderRenderer(group, headerProps, selectProps) {
  var groupLabelKey = selectProps.groupLabelKey,
      groupLabelGetter = selectProps.groupLabelGetter;
  var groupLabel = groupLabelGetter ? groupLabelGetter(group) : group[groupLabelKey];
  return /*#__PURE__*/React.createElement(_StyledLi2, _extends({}, headerProps, {
    $_css8: [theme.typography.bodySmall, {
      backgroundColor: theme.colors.charcoal050,
      padding: '8px 16px'
    }]
  }), groupLabel);
}

var _StyledDiv = _styled("div").withConfig({
  displayName: "defaultRenderers___StyledDiv",
  componentId: "sc-1te450h-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledButton = _styled("button").withConfig({
  displayName: "defaultRenderers___StyledButton",
  componentId: "sc-1te450h-1"
})(["", ""], function (p) {
  return p.$_css2;
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "defaultRenderers___StyledDiv2",
  componentId: "sc-1te450h-2"
})(["", ""], function (p) {
  return p.$_css3;
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "defaultRenderers___StyledDiv3",
  componentId: "sc-1te450h-3"
})(["", ""], function (p) {
  return p.$_css4;
});

var _StyledLi = _styled("li").withConfig({
  displayName: "defaultRenderers___StyledLi",
  componentId: "sc-1te450h-4"
})(["", ""], function (p) {
  return p.$_css5;
});

var _StyledDiv4 = _styled("div").withConfig({
  displayName: "defaultRenderers___StyledDiv4",
  componentId: "sc-1te450h-5"
})(["", ""], function (p) {
  return p.$_css6;
});

var _StyledSpan = _styled("span").withConfig({
  displayName: "defaultRenderers___StyledSpan",
  componentId: "sc-1te450h-6"
})(["", ""], function (p) {
  return p.$_css7;
});

var _StyledLi2 = _styled("li").withConfig({
  displayName: "defaultRenderers___StyledLi2",
  componentId: "sc-1te450h-7"
})(["", ""], function (p) {
  return p.$_css8;
});
//# sourceMappingURL=defaultRenderers.js.map